module.exports = __webpack_public_path__ + "img/submit.263dfab9.png";